/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { combineReducers } from 'redux';
import applicationReducer, { ApplicationStateProps } from './application';
import dashboardDoughnutReducer from './doughnutGraph';
import monthOnMonthReducer from './monthsGraph';
import topDistributorReducer from './topDistributors';
import commitmentAndContributionReducer from './commitmentAndContributionGraph';
import auth from './auth';
import errorReducer, { ErrorState } from './error';
import investorReducer from './investor';
import profileReducer from './profile';
import paramsReducer, { ParamsProps } from './queryParams';
import toast, { ToastType } from './toast';
import {
  dashboardOnboardingType,
  distributorWisecommitmentType,
  monthwiseCommitmentAmountType,
  monthwiseOnboardingSummaryType,
} from '../types/api-types';
import productsReducer, { ProductsType } from './product';
import valueConverterReducer from './valueConverter';
import investorProfileReducer, { InvestorProfileType } from './investorProfile';
import idReducer, { IdType } from './id';
import cartReducer, { CartType } from './cart';
import investmentDetailsReducer from './investmentDetails';
import { InvestmentFormType } from '../types/investmentdetails';
import portfolioReducer, { selectedPortfolioType } from './portfolioFilter';
import navbarInfoReducer, { NavbarInfoType } from './navbarInfo';
import currencyInfoReducer, { CurrencyInfoType } from './currencyInfo';
import sessionDataReducer, { SessionDataType } from './sessionData';
import nomineePopupReducer, { NomineePopupState } from './nomineePopup';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { MandateObj } from '../types/mandate';
import mandateReducer from './mandate';

export interface RootStateType {
  auth: any;
  router: any;
  profileReducer: any;
  dataDougnut: dashboardOnboardingType;
  monthOnMonthData: monthwiseOnboardingSummaryType;
  topDistributors: distributorWisecommitmentType;
  commitmentAndContributionData: monthwiseCommitmentAmountType;
  application: ApplicationStateProps;
  toast: ToastType;
  investor: any;
  error: ErrorState;
  paramsObj: ParamsProps;
  products: ProductsType;
  investorProfile: InvestorProfileType;
  id: IdType;
  cart: CartType;
  investmentFormData: InvestmentFormType;
  selectedPortfiolio: selectedPortfolioType;
  navbarInfo: NavbarInfoType;
  currencyInfo: CurrencyInfoType;
  sessionData: SessionDataType;
  savedMandateInfo: MandateObj;
  nomineePopup: NomineePopupState;
}
const sessionDataPersistConfig = {
  key: 'wa-user-session',
  storage: storageSession
}

export const rootReducer = (history: any) =>
  combineReducers({
    router: history,
    auth,
    profile: profileReducer,
    application: applicationReducer,
    dataDougnut: dashboardDoughnutReducer,
    monthOnMonthData: monthOnMonthReducer,
    commitmentAndContributionData: commitmentAndContributionReducer,
    topDistributors: topDistributorReducer,
    toast,
    investor: investorReducer,
    error: errorReducer,
    paramsObj: paramsReducer,
    products: productsReducer,
    valueConverter: valueConverterReducer,
    investorProfile: investorProfileReducer,
    id: idReducer,
    cart: cartReducer,
    investmentFormData: investmentDetailsReducer,
    selectedPortfiolio: portfolioReducer,
    navbarInfo: navbarInfoReducer,
    currencyInfo: currencyInfoReducer,
    savedMandateInfo: mandateReducer,
    sessionData: persistReducer(sessionDataPersistConfig, sessionDataReducer),
    nomineePopup: nomineePopupReducer
  });

export type RootState = ReturnType<typeof rootReducer>;
